'use strict'

import { apiInstance, legacyV2, legacyV3 } from './index'
import { FetchEntregaClient } from './fetchEntrega'
import { mapArgs } from 'utils/functions'

const company = {
  // new methods
  getById (companyId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/company/${companyId}`
    })
  },

  create (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV3()}/company/create`,
      data
    })
  },

  update (companyId, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3()}/company/${companyId}`,
      data
    })
  },

  // old methods
  getCompany (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/company`,
      params
    })
  },

  getCompanyById (companyId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/company/${companyId}`
    })
  },

  getCompanyConfig (companyId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/company/${companyId}/config`
    })
  },

  setCompanyConfig (companyId, ...args) {
    const data = mapArgs(...args)
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/company/${companyId}/config`,
      data
    })
  },

  setCompanyAllowWebCall (companyId, ...args) {
    const data = mapArgs(...args)
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/company/${companyId}/allowWebCall`,
      data
    })
  },

  getCompanyFinancialConfig (companyId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/company/${companyId}/financialConfig`
    })
  },

  editCompanyFinancialConfig (companyId, ...args) {
    const data = mapArgs(...args)
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/company/${companyId}/financialConfig`,
      data
    })
  },

  searchCompany (search) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/company?search=${search}&page=1&limit=50`
    })
  },

  bulkImport (company, formData, shouldSendWelcomeEmail = true) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/company/${company}/employee/upload`,
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
      data: formData,
      params: {
        shouldSendWelcomeEmail
      }
    })
  },

  bulkImportCostCenter (company, formData) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/company/${company}/costcenter/uploadXls`,
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
      data: formData
    })
  },

  bulkImportProject (company, formData) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV3()}/company/${company}/project/upload`,
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
      data: formData
    })
  },

  executeBulkOperation (companyId, bulkId, data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/company/${companyId}/bulkoperation/${bulkId}/execute`,
      data
    })
  },

  executeBulkOperationCostCenter (company, data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/company/${company}/bulkoperation/${data.id}/execute`
    })
  },

  allowPlatformAccessToAllEmployees (companyId) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/company/enableallemployee/v2permission`,
      data: { id: companyId }
    })
  },

  editCompanyStatus (companyId, status) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/company/${companyId}/disable`,
      data: {
        id: companyId,
        status
      }
    })
  },

  batchUpdate (companyId, ...args) {
    const data = mapArgs(...args)
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/company/${companyId}/employee/batchUpdate`,
      timeout: 60000,
      data
    })
  },

  costCenterMultiDelete (companyId, data) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2()}/company/${companyId}/costcenters`,
      data
    })
  },

  employeeMultiDelete (companyId, data) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2()}/company/${companyId}/employees`,
      data
    })
  },

  projectMultiDelete (companyId, data) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2()}/company/${companyId}/project/multiDelete`,
      data
    })
  },

  getFinancialConfigCompanies (ids) {
    const params = { companyIds: ids.toString() }
    return apiInstance({
      method: 'GET',
      url: `${legacyV3()}/company/financialConfig`,
      params
    })
  },

  requestApiToken (companyId, data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV3()}/requestApiToken/${companyId}`,
      data
    })
  },

  getWalletFinancialConfig (companyId) {
    return apiInstance({
      method: 'GET',
      url: `/b2b-wallet-app/financialAccount/${companyId}/financialConfig`
    })
  },

  setWalletFinancialConfig (companyId, data) {
    return apiInstance({
      method: 'PUT',
      url: `/b2b-wallet-app/financialAccount/${companyId}/financialConfig`,
      data
    })
  },

  createFinancialConfig (data) {
    return apiInstance({
      method: 'POST',
      url: `/b2b-wallet-app/financialAccount/financialConfig`,
      data
    })
  },

  updateCompanyPhone (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3()}/company/${id}/phone`,
      data
    })
  },

  employeeMultiDeleteById (companyId, data) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV3()}/company/${companyId}/employees/multiDelete`,
      data
    })
  },

  getTokenList ({ companyId }) {
    return FetchEntregaClient.fetchEntrega({
      method: 'GET',
      url: `/v1/token/list`,
      params: { company_id: companyId }
    })
  },

  getTokenDetail ({ tokenId }) {
    return FetchEntregaClient.fetchEntrega({
      method: 'GET',
      url: `/v1/token/detail`,
      params: { token_id: tokenId }
    })
  },

  updateToken ({ tokenId, enabled }) {
    return FetchEntregaClient.fetchEntrega({
      method: 'POST',
      url: `/v1/token/enabled`,
      data: { token_id: tokenId, enabled }
    })
  },

  addToken ({ companyId }) {
    return FetchEntregaClient.fetchEntrega({
      method: 'POST',
      url: `/v1/token`,
      data: { company_id: companyId }
    })
  }
}

export default company
